function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
//Material imports
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import makeStyles from "@mui/styles/makeStyles";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import PortalButton from "../../buttons/portal-button/PortalButton";
import TooltipButton from "../../buttons/tooltip-button/TooltipButton";
const useStyles = makeStyles(theme => ({
  dialogActions: {
    padding: 16,
    minWidth: 285,
    alignSelf: "flex-end"
  },
  dialogChildContent: {
    marginLeft: 16,
    marginRight: 16,
    padding: "0px 8px"
  },
  dialogContentContainer: {
    backgroundColor: theme.background.default,
    marginLeft: 16,
    marginRight: 16,
    padding: "16px !important"
  },
  cancelButton: {
    height: 45,
    minHeight: 45
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: 0,
    padding: "5px"
  }
}));
const OkCancelDialog = ({
  title,
  children,
  dialogProps,
  dialogTitleProps,
  dialogContentProps,
  okLabel = "Ok",
  okId,
  cancelLabel = "Cancel",
  cancelId,
  onOKClick,
  onCancelClick,
  okDisabled = false,
  okDisabledTooltip = "",
  open = true,
  maxWidth,
  dialogChildContentProps,
  extraButtonComponent = null,
  cancelDisabled = false,
  showCloseIcon = false
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const dialogContentChildren = React.useMemo(() => {
    if (!children) {
      return null;
    }
    const defaultContentProps = {
      classes: {
        root: clsx(classes.dialogContentContainer, classes.dialogContentBackground, {
          overflow: "visible"
        })
      }
    };
    const contentProps = dialogContentProps || defaultContentProps;
    if (Array.isArray(children)) {
      try {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogContent, contentProps, children[0]), /*#__PURE__*/React.createElement(DialogContent, _extends({
          classes: {
            root: classes.dialogChildContent
          }
        }, dialogChildContentProps), children.map((child, index) => {
          if (index !== 0) {
            return child;
          }
          return null;
        })));
      } catch {
        return /*#__PURE__*/React.createElement(DialogContent, contentProps, children);
      }
    }
    return /*#__PURE__*/React.createElement(DialogContent, contentProps, children);
  }, [children, dialogContentProps]);
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    open: open,
    maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : "md",
    onClose: (event, reason) => {
      if (reason === "backdropClick") {
        if (dialogProps !== null && dialogProps !== void 0 && dialogProps.onBackdropClick) {
          dialogProps.onBackdropClick(event);
        } else {
          if (typeof onCancelClick === "function") {
            onCancelClick();
          }
        }
      }
    }
  }, dialogProps), /*#__PURE__*/React.createElement(Grid, {
    sx: {
      padding: "24px!important"
    }
  }, title && /*#__PURE__*/React.createElement(DialogTitle, dialogTitleProps, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "subtitle1",
    component: "span"
  }, t(title)), showCloseIcon ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      if (dialogProps !== null && dialogProps !== void 0 && dialogProps.onBackdropClick) {
        dialogProps.onBackdropClick();
      } else {
        onCancelClick();
      }
    },
    className: classes.closeButton
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    fontSize: "small"
  })) : null), dialogContentChildren, /*#__PURE__*/React.createElement(DialogActions, {
    classes: {
      root: classes.dialogActions
    }
  }, onCancelClick && /*#__PURE__*/React.createElement(PortalButton, {
    onClick: onCancelClick,
    variant: "outlined",
    size: "small",
    id: cancelId,
    disabled: cancelDisabled,
    buttonClasses: classes.cancelButton
  }, cancelLabel), extraButtonComponent, /*#__PURE__*/React.createElement(TooltipButton, {
    onClick: onOKClick,
    buttonProps: {
      disabled: okDisabled,
      color: "secondary",
      variant: "contained",
      id: okId,
      size: "large",
      fullWidth: true
    },
    allowButtonClasses: false,
    tooltipTitle: okDisabled ? okDisabledTooltip : "",
    placement: "top"
  }, okLabel))));
};
export default OkCancelDialog;
OkCancelDialog.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  okLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onOKClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func,
  dialogProps: PropTypes.object,
  dialogTitleProps: PropTypes.object,
  okDisabled: PropTypes.bool,
  dialogContentProps: PropTypes.object,
  open: PropTypes.bool,
  okId: PropTypes.string,
  maxWidth: PropTypes.string,
  cancelId: PropTypes.string,
  okDisabledTooltip: PropTypes.string,
  dialogChildContentProps: PropTypes.object,
  extraButtonComponent: PropTypes.node,
  cancelDisabled: PropTypes.bool,
  showCloseIcon: PropTypes.bool
};